exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".manageAdPage__title___3fWzQ,\n.manageAdPage__username___3p3f5 {\n  color: blue; }\n\n.manageAdPage__title___3fWzQ {\n  min-width: 160px;\n  display: block; }\n\n.manageAdPage__blockCheckbox____dz0Z {\n  width: 16px;\n  height: 16px;\n  display: inline-block; }\n\n.manageAdPage__table___2VJ2N {\n  padding-top: 39px; }\n\n.manageAdPage__adCode___yECrj {\n  display: block;\n  text-align: center;\n  width: 100%;\n  margin-bottom: 20px; }\n\n.manageAdPage__price___3ZOzG {\n  display: block;\n  text-align: center;\n  width: 100%;\n  margin-top: 20px;\n  font-weight: bold;\n  color: red; }\n\n.manageAdPage__table___2VJ2N .ant-table-expanded-row .ant-table-pagination {\n  float: none !important;\n  text-align: center; }\n\n.manageAdPage__loading___3kJEx {\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100vh;\n  width: 100vw;\n  background: rgba(255, 255, 255, 0.3);\n  z-index: 1000;\n  display: flex;\n  justify-content: center;\n  align-items: center; }\n", ""]);

// exports
exports.locals = {
	"title": "manageAdPage__title___3fWzQ",
	"username": "manageAdPage__username___3p3f5",
	"blockCheckbox": "manageAdPage__blockCheckbox____dz0Z",
	"table": "manageAdPage__table___2VJ2N",
	"adCode": "manageAdPage__adCode___yECrj",
	"price": "manageAdPage__price___3ZOzG",
	"loading": "manageAdPage__loading___3kJEx"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/routes/Admin/ManageAdPage/manageAdPage.scss
// module id = 2019
// module chunks = 6